
import Vue from "vue";
import Component from "vue-class-component";
import draggable from "vuedraggable";
import {formatDate, formatAddress, formatDecimal, formatBool} from "@/utils";
import TruckMap from "@/components/truck/TruckMap.vue";
import {Truck} from "@/models/api/trucks/getTrucks";
import TruckModule from "@/store/modules/truck";
import {getModule} from "vuex-module-decorators";
import {getTruckCubeWarningLevel} from "@/store/modules/truck/helpers";
import {Address, OrderParty} from "@/models/api/orders/get";
import {OrderModule} from "@/store/modules";
import Select from "../form/Select.vue";
import _ from "lodash";
import moment from "moment";
import {State} from "@/models/api/system/states";
import {timeframeEntryModal} from "@/lib/modals";
import {UpdateTruckDetailSequenceRequest} from "@/models/api/trucks/updateDetailSequence";
import notifications from "@/lib/notifications";
import {mapActions} from "vuex";

const orderModule = getModule(OrderModule);
const truckModuleState = getModule(TruckModule);

@Component({
  methods: {
    timeframeEntryModal() {
      return timeframeEntryModal
    },
    ...mapActions("truck", {
      updateTruckDetailSequence: "updateTruckDetailSequence"
    })
  },
  components: {
    draggable,
    TruckMap,
    Select
  }
})
export default class RouteTruckView extends Vue {
  $refs!: {
    truckMap: TruckMap;
  };
  localTruck: Truck = null;
  additionalInfoOrder: any = null;
  showOrderAdditionalInfo: boolean = false;
  updating: boolean = false;
  selectedStartPoint: any = 0;
  options: Array<Object> = [];
  newOriginAddress1: string = null;
  newOriginAddress2: string = null;
  newOriginCity: string = null;
  newOriginState: string = null;
  newOriginZipCode: string = null;
  newOriginName: string = null;
  newOriginId: any = null;
  newOriginIsActive: boolean = false;
  startTime: string = "06:00";
  states: Array<Object> = [];
  isLoading: boolean = false;
  showDistance: boolean = false;
  showTime: boolean = false;
  isSaving: boolean = false;

  showModal() {
    this.$bvModal.show("addNewOriginModal");
  }

  async created() {
    if (truckModuleState.currentTruck) {

      this.localTruck = JSON.parse(JSON.stringify(truckModuleState.currentTruck));
      this.setOrigins();
      const localStates = await truckModuleState.getStates();
      this.states = _.map(localStates, (item) => {
        return {
          label: item.name,
          value: item.code
        }
      });

    }
  }

  repopulateOrder(order)
  {
    if(order && this.localTruck && this.localTruck.orders){
      let orderIndex = this.localTruck.orders.findIndex((x) => x.id == order.id);
      if(orderIndex >= 0)
        this.localTruck.orders.splice(orderIndex, 1, JSON.parse(JSON.stringify(order)));
    }
  }

  get deliveryDate() {
    return this.localTruck.deliveryDate;
  }

  set deliveryDate(val) {
  }

  get truckName() {
    return this.localTruck.name;
  }

  set truckName(val) {
  }

  get driverName() {
    return this.localTruck.driverName;
  }

  set driverName(val) {
  }

  get maxCubes() {
    return this.localTruck.maxCubes;
  }

  set maxCubes(val) {
  }

  get truckOrdersWithGPS(): any[] {
    return this.localTruck.orders.filter(x => x.location);
  }

  get truckZips() {
    return this.localTruck.zip3sServiced.join(", ");
  }

  set truckZips(value) {

  }

  addLocation() {
    this.newOriginAddress1 = null;
    this.newOriginAddress2 = null;
    this.newOriginCity = null;
    this.newOriginState = null;
    this.newOriginZipCode = null;
    this.newOriginName = null;
    this.newOriginId = null;
    this.newOriginIsActive = null;
    this.showModal();
  }

  async editLocation() {
    const result = await truckModuleState.getOriginData(this.selectedStartPoint);
    this.newOriginAddress1 = result.address1;
    this.newOriginAddress2 = result.address2;
    this.newOriginCity = result.city;
    this.newOriginState = result.state;
    this.newOriginZipCode = result.zipCode;
    this.newOriginName = result.name;
    this.newOriginId = result.id;
    this.newOriginIsActive = result.isActive;
    this.showModal();
  }

  setOrigins() {
    this.options = this.options.concat(_.map(this.localTruck.facilityOrigins, (x => {
      return {
        label: x.name,
        value: x.id
      }
    })));
  }

  getTotalCubesForTruck(truck: Truck): number {
    return truck.orders.reduce((sum, item) => sum + item.cubes, 0);
  }

  format(date) {
    return formatDate(date);
  }

  get summary() {
    return truckModuleState.splitTruckSummary;
  }

  hideModal() {
    this.$bvModal.hide("addNewOriginModal");
    this.newOriginAddress1 = null;
    this.newOriginAddress2 = null;
    this.newOriginCity = null;
    this.newOriginState = null;
    this.newOriginZipCode = null;
    this.newOriginName = null;
    this.newOriginId = null;
    this.newOriginIsActive = false;
  }

  async saveNewOrigin() {
    const model = {
      name: this.newOriginName,
      facilityCode: this.localTruck.facilityCode,
      address1: this.newOriginAddress1,
      address2: this.newOriginAddress2,
      city: this.newOriginCity,
      state: this.newOriginState,
      zipCode: this.newOriginZipCode,
      truckId: this.localTruck.id
    }

    try {
      this.localTruck = await truckModuleState.addNewOrigin(model);
      this.options = _.map(this.localTruck.facilityOrigins, (x => {
        return {
          label: x.name,
          value: x.id
        }
      }));
      notifications.success("Origin", "Origin successfully added.")
    } catch {
      notifications.error("Route Sequencing", "Unknown error has occurred.  Please try again.");
    } finally {
      this.hideModal();
    }
  }

  async updateOrigin() {
    const model = {
      name: this.newOriginName,
      facilityCode: this.localTruck.facilityCode,
      address1: this.newOriginAddress1,
      address2: this.newOriginAddress2,
      city: this.newOriginCity,
      state: this.newOriginState,
      zipCode: this.newOriginZipCode,
      truckId: this.localTruck.id,
      isActive: this.newOriginIsActive,
      id: this.newOriginId
    }

    try {
      const updatedResults = await truckModuleState.updateOrigin(model)

      const slicedArray = _.remove(this.options, x => {
        return x.value === 0;
      });

      this.options = slicedArray;

      this.options = this.options.concat(_.map(updatedResults, x => {
        return {
          label: x.name,
          value: x.id
        }
      }));

      this.selectedStartPoint = 0;
      notifications.success("Origin", "Origin successfully updated.")
    } catch {
      notifications.error("Origin", "Unknown error has occurred.  Please try again.");
    } finally {
      this.hideModal();
    }
  }

  colStyle(index: number, columnName: string) {
    return index % 2 === 0 ? `col ${columnName} striped` : `col ${columnName}`;
  }

  getCubeWarningClass(truck: Truck): string {
    let warningLevel = getTruckCubeWarningLevel(this.getTotalCubesForTruck(truck), truck.maxCubes);
    return "truck-cube-warning-" + warningLevel.toString();
  }

  getOrderPosition(order: any) {
    if (order && order.location)
      return {lat: order.location.latitude, lng: order.location.longitude};
    return null;
  }

  onClickMapPin(order) {
    this.$refs.truckMap.selectTruckMapOrder(order);
  }

  onClickNoMapPin(order) {
    this.$refs.truckMap.geoCodeTruckOrder(order);
  }

  formatAddress(address: Address) {
    return formatAddress(address);
  }

  formatDecimal(value) {
    return formatDecimal(value);
  }

  formatBool(value) {
    return formatBool(value);
  }

  onClickAdditionalInfo(order) {
    this.previewOrder(order.orderHeaderNumber);
  }

  onClickViewNotes(order) {
    this.viewNotes(order.orderHeaderNumber);
  }

  previewOrder(orderHeaderNumber) {
    orderModule.orderPreviewShortcutAction({selectedItems: [{number: orderHeaderNumber}]});
  }

  viewNotes(orderHeaderNumber) {
    orderModule.notesShortcutAction({selectselectedItems: [{number: orderHeaderNumber}]})
  }

  hasAdditionalInfo(order) {
    return (order.orderHeaderNumber != null)
  }

  closeAdditionalInfo() {
    this.additionalInfoOrder = null;
    this.showOrderAdditionalInfo = false;
  }

  updateTruckDetailSequence: (
    request: UpdateTruckDetailSequenceRequest
  ) => Promise<void>;

  async saveRoute() {
    this.isSaving = true;
    let detailSequences = [];
    let orders = this.localTruck.orders;

    for (var i = 0; i < orders.length; i++) {
      detailSequences.push({truckDetailId: orders[i].id, sequence: i + 1})
    }

    let request = {
      truckId: this.localTruck.id,
      detailSequences: detailSequences
    } as UpdateTruckDetailSequenceRequest


    await this.updateTruckDetailSequence(request)
      .then(() => {
        notifications.success(
          "Order Resequenced",
          "Order successfully sequenced on truck."
        );
      })
      .catch(ex => {
        notifications.error(
          "Error Resequencing Orders",
          "Failed to resequence orders",
          ex
        );
      });

    await truckModuleState.loadTruck(this.localTruck.id);
    this.isSaving = false;
  }

  async autoSequenceTruck() {
    this.isLoading = true;
    try {
      const routedSequence = await truckModuleState.sequenceTruck({
        truckId: this.$refs.truckMap.truck.id,
        startingPoint: this.selectedStartPoint.toString(),
        startTime: this.startTime
      });
      this.localTruck = routedSequence;
      notifications.success("Route Sequencing", "Order successfully sequenced on truck.")
    } catch {
      notifications.error("Route Sequencing", "Unknown error has occurred.  Please try again.");
    }

    this.showTime = true;
    this.showDistance = true;
    this.isLoading = false;
  }

  async autoSequenceTruckReverse() {
    this.isLoading = true;
    try {
      const routedSequence = await truckModuleState.sequenceTruckReverse({
        truckId: this.$refs.truckMap.truck.id,
        startingPoint: this.selectedStartPoint.toString(),
        startTime: this.startTime
      });
      this.localTruck = routedSequence;
      notifications.success("Route Sequencing","Order successfully reverse sequenced on truck.")
    } catch {
      notifications.error("Route Sequencing", "Unknown error has occurred.  Please try again.");
    }

    this.showTime = true;
    this.showDistance = true;
    this.isLoading = false;
  }

  getMapPinIconColor(order: any) {
    if (order && order.deliveryType == "RETURN")
      return "red";

    if (order && order.location && order.location.isZipCodeLocation == true)
      return "red";

    return "green";
  }

  dragEnd(event) {
    this.updating = true;
    const orders = [...this.localTruck.orders];
    for (var i = 0; i < orders.length; i++) {
      orders[i].sequence = i + 1;
    }

    const valuesToSet = orders.map(x => {
      return {
        orderHeaderNumber: x.orderHeaderNumber,
        sequence: x.sequence
      }
    })


    this.localTruck.orders = _.orderBy(orders, ['sequence']) ;
    truckModuleState.setTruckOrder(valuesToSet);

    this.$nextTick(() => {
      this.updating = false;
      this.showTime = false;
    });
  }
}
